import { API_URL } from '../../config';
import { CALL_API } from '../../middlewares/apiMiddleware';
import { CONFIRM_MAIL_CONFIRM, PENDING, FULFILLED, REJECTED } from '../../globals';



export function confirmEmailRequest(){
  return {
    type: `${CONFIRM_MAIL_CONFIRM}_${PENDING}`,
  };
}

export function confirmEmailSuccess(response){
  return {
    type: `${CONFIRM_MAIL_CONFIRM}_${FULFILLED}`,
  };
}

export function confirmEmailFailure(response){
  return {
    type: `${CONFIRM_MAIL_CONFIRM}_${REJECTED}`,
    payload: {
      time: (response.response && response.response.data.message.message.time !== undefined) ? response.response.data.message.message.time : true,
      completed: (response.response && response.response.data.message.message.completed !== undefined) ? response.response.data.message.message.completed : true,
      deleted: (response.response && response.response.data.message.message.deleted !== undefined) ? response.response.data.message.message.deleted : true,
      emailConfirmed: (response.response && response.response.data.message.message.email_confirmed !== undefined) ? response.response.data.message.message.email_confirmed : true,
    }
  };
}


export const confirmEmail = (emailHash) => ({
  [CALL_API]: {
    actions: [confirmEmailRequest, confirmEmailSuccess, confirmEmailFailure],
    url: `${API_URL}/web/order/complete-reservation?hash=${emailHash}`,
  },
});



// WEBPACK FOOTER //
// ./src/components/EmailConfirmContent/actions.js